"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getValidFeaturedCollectionsResultsHeaders = exports.getValidFeaturedCollectionCalloutConfigs = void 0;

var _reselect = require("reselect");

var _env = require("../utils/env");

var _auth = require("./auth");

var getFeaturedCollectionConfigs = function getFeaturedCollectionConfigs(state) {
  return state.featuredCollections;
};

var getValidFeaturedCollectionConfigs = (0, _reselect.createSelector)([getFeaturedCollectionConfigs, _auth.getIsUngated], function (featuredCollections, isUngated) {
  return featuredCollections.filter(function (collectionConfig) {
    if ((0, _env.debug)("featured-" + collectionConfig.get('collection'))) {
      return true;
    }

    if (collectionConfig.has('gate')) {
      return isUngated(collectionConfig.get('gate'));
    }

    return true;
  });
});
var getValidFeaturedCollectionCalloutConfigs = (0, _reselect.createSelector)([getValidFeaturedCollectionConfigs], function (validConfigs) {
  return validConfigs.filter(function (collectionConfig) {
    return collectionConfig.get('showCallout', false);
  });
});
exports.getValidFeaturedCollectionCalloutConfigs = getValidFeaturedCollectionCalloutConfigs;
var getValidFeaturedCollectionsResultsHeaders = (0, _reselect.createSelector)([getValidFeaturedCollectionConfigs], function (validConfigs) {
  return validConfigs.filter(function (collectionConfig) {
    return collectionConfig.get('showResultsHeader') === true;
  });
});
exports.getValidFeaturedCollectionsResultsHeaders = getValidFeaturedCollectionsResultsHeaders;


//////////////////
// WEBPACK FOOTER
// ./js/selectors/featuredCollections.js
// module id = 442
// module chunks = 209 210 211 212